import React from "react";
import { PanelFrame } from "../ui/PanelFrame";

export function RightRailHome() {
  return (
    <PanelFrame>
      <div
        style={{
          fontSize: 12,
          letterSpacing: "0.16em",
          color: "#8fa8e8",
          marginBottom: 6,
          textAlign: "center",
        }}
      >
        LIVE SNAPSHOT
      </div>
      <div
        style={{
          marginTop: 4,
          padding: 8,
          fontSize: 11,
          borderRadius: 8,
          border: "1px solid rgba(255,255,255,0.08)",
          background: "rgba(3,6,12,0.98)",
          minHeight: 80,
        }}
      >
        Platzhalter:
        <br />
        Letzter Import, Dörfer je Welt, aktive Server.
      </div>

      <div
        style={{
          fontSize: 12,
          letterSpacing: "0.16em",
          color: "#8fa8e8",
          marginTop: 14,
          marginBottom: 6,
          textAlign: "center",
        }}
      >
        KOMMENDE FEATURES
      </div>
      <div
        style={{
          marginTop: 4,
          padding: 8,
          fontSize: 11,
          borderRadius: 8,
          border: "1px solid rgba(255,255,255,0.08)",
          background: "rgba(3,6,12,0.98)",
          minHeight: 60,
        }}
      >
        Reserviert für Hinweise, Banner,
        Kooperationen oder wichtige News.
      </div>
    </PanelFrame>
  );
}
